<ng-container *ngIf="dataset">
    <div mat-dialog-title>
        {{'FILE_LIST.NAV.ALIGN_BOUNDS' | translate }} - {{ dataset.name}}
    </div>
    <div mat-dialog-content>
        <align-bounds [dataset]="dataset"></align-bounds>
    </div>
    <div mat-dialog-actions style="text-align:right;align-items:inherit!important;justify-content:flex-end!important;">
        <button mat-raised-button (click)="cancel()" >{{ 'GENERIC.CLOSE' | translate }}</button>
        <button mat-raised-button  color="warn" class="float-right ml-2 mr-2" (click)="save()" [disabled]="!dataset.crs">{{ 'GENERIC.NEXT' | translate }} <fa-icon icon="arrow-right"></fa-icon></button>
    </div>
</ng-container>